import { useState } from "react";

import { Botao, Cores, Corpo, Icone, NomeIcone } from "@componentes-mu/componentes-mu";

import styles from "./styles.module.scss";

export type StatusOptionsProps = {
    value: string;
    description: string;
    icon?: NomeIcone | "";
    onClick: (id: string) => void;
}


export type StatusGroupOptionsProps = {
    options: StatusOptionsProps[];
    value: string
}

export const StatusGroupOptions = ({ options, value }: StatusGroupOptionsProps) => {

    const [selecionado, setSelecionado] = useState<string>(value);


    const handleClick = (option: StatusOptionsProps) => {
        setSelecionado(option.value);
        option.onClick(option.value);
    }

    return (
        <div className={styles.optionContainer}>
            {options.map((option) => (
                <div
                    key={option.value}
                    className={`
                        ${styles.option} 
                        ${selecionado === option.value ? styles.selected : ''}
                    `}>
                    <Botao
                        id={option.value}
                        tipoComportamento="button"
                        onClick={() => handleClick(option)}
                        estilo="ghost"
                        tamanho="medium"
                    >
                        {option.icon && <Icone
                            nome={option.icon}
                            cor={selecionado === option.value ? Cores.GradacaoNeutros.CinzaFillMU100 : Cores.GradacaoPrimaria.AzulMedioMU600}
                        />}
                        <Corpo
                            tipo="button1"
                            negrito={700}
                            cor={selecionado === option.value ? Cores.GradacaoNeutros.CinzaFillMU100 : Cores.GradacaoPrimaria.AzulMedioMU600}
                        >
                            {option.description}
                        </Corpo>
                    </Botao>
                </div>
            ))}
        </div>
    )
}